export const styles = {
  contentContainer: {
    height: '100%',
  },

  containerStyles: {
    height: '100%',
  },
};
